import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button } from '../components/input';
import { Loading } from '../components/loading';
import { SectionCard } from '../components/card';
import { LeftNav } from '../components/nav';
import { AddPaymentMethod, AddCredits, AutoReload, CardDisplay } from '../components/billing';
import { Modal } from '../components/modal';
import { useCredits, useGlobal } from '../state';

const centerStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0',
  gap: 4,
  alignItems: 'center',
  justifyContent: 'flex-start',
  height: '100%',
  width: '100%',
};

const AddCardModal = () => {
  const { refreshUser } = useGlobal();
  const [close, setClose] = useState();

  const handleSuccess = async () => {
    await refreshUser();
    setClose(true);
  };

  return (
    <Modal close={close}>
      <Button>Add Payment Method</Button>
      <div style={{ width: 500 }}>
        <AddPaymentMethod onSuccess={handleSuccess} />
      </div>
    </Modal>
  );
};

export default function Billing() {
  const { user } = useGlobal();
  const { credits } = useCredits();

  return (
    <LeftNav>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        <div style={{ display: 'flex', gap: 20 }}>
          <SectionCard title="Remaining Credits" style={{ width: '50%' }}>
            <div style={centerStyle}>
              <div style={{ fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>
                {!credits?.balance && <Loading />}
                {credits?.balance && <span>${(credits?.balance?.remaining / 1000).toFixed(2)}</span>}
              </div>
              <div></div>
            </div>
          </SectionCard>

          <SectionCard title="Payment Method" style={{ width: '50%' }}>
            <div style={centerStyle}>
              {user && !user.paymentMethodId && <AddCardModal />}
              {user && user.paymentMethodId && <CardDisplay />}
            </div>
          </SectionCard>
        </div>

        <div style={{ display: 'flex', gap: 20 }}>
          <SectionCard title="Purchase Credits" style={{ width: '50%' }}>
            <div style={centerStyle}>
              <AddCredits />
            </div>
          </SectionCard>

          <SectionCard title="Auto Reload" style={{ width: '50%' }}>
            <div style={centerStyle}>
              <AutoReload />
            </div>
          </SectionCard>
        </div>
      </div>

      {/*
            <pre>{JSON.stringify(credits, null, 2)}</pre>
            <pre>{JSON.stringify(user, null, 2)}</pre>
          */}
    </LeftNav>
  );
}
